import axios from "axios";
var headers = {};

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_SERVER_BASE_URL,
    headers: headers
});

export default axiosInstance;